import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';

import { ISportEvent } from '@frontend/oxygen/shared-utils';

import { SBreactionConfig } from '../../../../core/services/cms/models';
import { FracToDecService } from '../../../../core/services/fracToDec/frac-to-dec.service';
import { AWSFirehoseService } from '../../../../lazy-modules/awsFirehose/service/aws-firehose.service';
import { ISurfaceBetEvent } from '../../../models/surface-bet-event.model';
import { SBSingleReaction } from '../../../models/surface-bet-module.model';

@Component({
    selector: 'odds-card-surface-bet',
    templateUrl: './odds-card-surface-bet.component.html',
    styleUrls: ['./odds-card-surface-bet.component.scss'],
    standalone: false,
})
export class OddsCardSurfaceBetComponent implements OnInit, OnChanges {
    @Input() surfaceBet: ISurfaceBetEvent;
    @Input() surfaceBetIndex?: number;
    @Input() sbReactionConfig: SBreactionConfig;
    @Input() singleReactionCount: SBSingleReaction;
    @Input() sportId: number;
    @Input() sportName: string;
    @Input() hubIndex: number;
    @Input() isEdp: boolean;
    @Output() sBreactionsLoaded: EventEmitter<boolean> = new EventEmitter();

    public oldPrice: string | undefined;
    public isButton: boolean;
    enable_reactions: boolean;
    emoji_selected: boolean;
    globalCount: number = 0;
    reactionSaved: boolean = false;
    userReaction: string = '';
    emojiClickListener: Function;

    constructor(
        protected fracToDecService: FracToDecService,
        protected aws: AWSFirehoseService,
    ) {}

    ngOnInit(): void {
        this.setOldPrice();
    }

    ngOnChanges(): void {
        this.isButton = Boolean((this.surfaceBet as ISportEvent)?.markets?.[0]?.outcomes?.[0]);
        this.setOldPrice();
    }

    /**
     * triggers when sb reactions loaded
     */
    reactionsLoaded() {
        this.sBreactionsLoaded.emit(true);
    }

    private setOldPrice(): void {
        const wasPrice = this.surfaceBet?.markets?.[0]?.outcomes?.[0]?.name?.toLowerCase()?.split('(was ');
        if (wasPrice && wasPrice.length > 1) {
            const wasPriceSplit = wasPrice[1].replace(/[)]/gi, '').trim().split('/');
            this.oldPrice = <string>this.fracToDecService.getFormattedValue(Number(wasPriceSplit[0]), Number(wasPriceSplit[1]));
        } else {
            this.oldPrice = undefined;
        }
    }
}
